import styled from "styled-components";

export const EmailContainer = styled('div')`
    width: auto;
    margin-top: 1px;
    font-size: 10px;
    line-height: 12px;
`;

export const ContactUs = styled('a')`
    color: #134FBD;
    font-family: "Proxima Nova";
    font-size: 10px;
    font-style: normal;
    font-weight: 700 !important;
    line-height: 12px;
`;
